var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({width:_vm.width}),attrs:{"id":"mountNode"}},[_c('div',{staticClass:"editor"},[_c('div',{staticClass:"bottom-container"},[_c('Edit')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }